/**
 * External dependencies
 */
import React from "react";
import classnames from "classnames";
import { Text } from "components/text";

import "./styles.scss";

const FormInputCheckbox = ({ className, label, ...otherProps }) => (
  <label className={classnames(className, "form-checkbox")}>
    <input {...otherProps} type="checkbox" className={"form-checkbox__input"} />
    <Text variant="bodyLg" fontWeight="semiBold">
      {label}
    </Text>
  </label>
);

export default FormInputCheckbox;
